import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=d91b5c0a&scoped=true"
import script from "./Customization.vue?vue&type=script&lang=js"
export * from "./Customization.vue?vue&type=script&lang=js"
import style0 from "./Customization.vue?vue&type=style&index=0&id=d91b5c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91b5c0a",
  null
  
)

export default component.exports